import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  const [jsonContent, setJsonContent] = useState('加载中...')
  useEffect(() => {
    fetch('https://web3-yideng.wangjiafeng1996.workers.dev')
      .then(response => response.json())
      .then(data => {
        setJsonContent(data?.message || '加载失败')
        console.log(data)
      })
      .catch(error => console.error('Error:', error));
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <p>
          {jsonContent}
        </p>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
